import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { usePagesTranslation } from "../locales";
import StorybookReader from "./StorybookReader";

/**
 * Full-page story detail (puzzle-of-day, read-story) — same reader as storybook selection.
 */
export default function HomeStoryDetailView({
    row,
    loading,
    detailLoading,
    error,
    contentLanguage,
    pageTitle,
}) {
    const { t } = usePagesTranslation();

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Typography color="error" sx={{ py: 2 }}>
                {t("landing.puzzle-of-day-error")}
            </Typography>
        );
    }

    if (!row) {
        return (
            <Typography color="text.secondary" sx={{ py: 2 }}>
                {t("landing.puzzle-of-day-empty")}
            </Typography>
        );
    }

    return (
        <>
            {pageTitle ? (
                <Typography variant="h5" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
                    {pageTitle}
                </Typography>
            ) : null}
            <StorybookReader
                row={row}
                contentLanguage={contentLanguage}
                loadingDetail={detailLoading}
                headingComponent={pageTitle ? "h2" : "h1"}
            />
        </>
    );
}
